import React, { useState } from 'react';

type SendDeleteEmailProps = {
    setModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  };
  
  const SendSupportEmail: React.FC<SendDeleteEmailProps> = ({ setModalVisible }) => {
  const [email, setEmail] = useState('Fedia@hotmail.co.uk');
  const [isEmailValid, setEmailValid] = useState(true); 
  const [placeholderText, setPlaceholderText] = useState('Your Question');

  const validateEmail = (email: string) => {
    const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return regex.test(email);
  };

  const handleSignUpClick = async () => {
    setModalVisible(true)

    if (validateEmail(email)) {
      // Here, we make a POST request to our Next.js API route
      try {
        const response = await fetch('/api/sendEmail', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: email, // Assuming the API expects an object with an email property
          }),
        });
  
        const data = await response.json();
        if (response.ok) {
          console.log(data.message); // Or handle this message in the UI
          setEmailValid(true);
          setEmail(''); // Clear the email input
          setPlaceholderText('Your Question'); // Reset placeholder
        } else {
          throw new Error(data.message || 'Failed to send email');
        }
      } catch (error) {
        console.error('Error:', error);
        // Optionally handle the error state in the UI, e.g., showing an error message
      }
    } else {
      setEmailValid(false);
      setEmail('');
      setPlaceholderText('Please enter a valid email');
    }
  };
  
  // Reset placeholder and validation state when the input is focused
  const handleFocus = () => {
    setPlaceholderText('Your Question');
    setEmailValid(true);
  };


  return (
    <>
      <style jsx global>{`
        .newsletterEmailInput::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: inherit; /* Default placeholder color */
        opacity: 1; /* Firefox */
      }

      .newsletterEmailInput.invalid::placeholder { /* Change placeholder color when email is invalid */
        color: red; /* Red placeholder color */
      }

      /* Internet Explorer 10-11 */
      .newsletterEmailInput:-ms-input-placeholder {
        color: inherit;
      }

      .newsletterEmailInput.invalid:-ms-input-placeholder {
        color: red;
      }

      /* Microsoft Edge */
      .newsletterEmailInput::-ms-input-placeholder {
        color: inherit;
      }

      .newsletterEmailInput.invalid::-ms-input-placeholder {
        color: red;
      }




        .newsletterContainer {
          color: white;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 50px 0;
          font-family: 'Arial, sans-serif';
        }

        .newsletterSignupForm {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .newsletterEmailInput {
          padding: 10px;
          margin-right: 10px;
          font-size: 1rem;
          color: black;
          border: none;
          border-radius: 5px;
          width: 450px;
        }

        .newsletterSignUpButton {
          background-color: rgb(150, 95, 220);
          color: black;
          border: none;
          border-radius: 20px;
          padding: 10px 20px;
          cursor: pointer;
          font-size: 1rem;
          transition: background-color 0.3s ease; /* Transition for the hover effect */
        }

        .newsletterSignUpButton:hover {
          background-color: #00CC00; /* Darker shade of green on hover */
        }

        .edit-bottom-modal {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 400px;
          height: 400px;
          background-color: black;
          padding: 20px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          z-index: 1000;
          border: 2px solid green;
          flex-direction: column;
        }
  

        



        /* Responsive adjustments for screens narrower than 800px */
@media (max-width: 800px) {

  .newsletterEmailInput {
    width: 80%; /* Adjust width to be more responsive */
    font-size: 0.9rem; /* Slightly smaller font size */
  }

  .newsletterSignUpButton {
    padding: 8px 15px; /* Adjust padding */
    font-size: 0.9rem; /* Slightly smaller font size */
  }

  .edit-bottom-modal {
    width: 90%; /* Increase width for better visibility */
    padding: 15px; /* Adjust padding */
  }
}
@media (max-width: 500px) {
  .edit-bottom-modal {
    width: 80%; /* Adjust width to be 80% of the screen width */
    height: auto; /* Adjust height to be auto to maintain aspect ratio */
    padding: 10px; /* Reduce padding */
  }
}
/* Further responsive adjustments for screens narrower than 400px */
@media (max-width: 400px) {

  .newsletterEmailInput {
    font-size: 0.8rem; /* Further reduced font size */
  }

  .newsletterSignUpButton {
    font-size: 0.8rem; /* Further reduced font size */
  }

  .edit-bottom-modal {
    padding: 10px; /* Further reduce padding */
  }
}

  
      `}</style>

      <div className="newsletterContainer">
        <div className="newsletterSignupForm">
          <input
            type="text"
            placeholder={placeholderText}
            onChange={(e) => setEmail(e.target.value)}
            className={`newsletterEmailInput ${!isEmailValid ? 'invalid' : ''}`}
            onFocus={handleFocus} 
          />
          <button className="newsletterSignUpButton" onClick={ handleSignUpClick }>Submit</button>
        </div>


      </div>

    </>
  );
};

export default SendSupportEmail;


